// src/components/contexts/RoomsContext.js
import React, { createContext, useState } from 'react';

const RoomsContext = createContext();

export const RoomsProvider = ({ children }) => {
  // Slots visibles para selección
  const [rooms, setRooms] = useState([
    { adultsCount: 2, childrenCount: 0, isInCart: false, roomNumber: 1, preferenceRate: true }
  ]);

  // Mapeo estable: groupId (base del carrito) -> roomNumber (slot)
  const [groupSlotMap, setGroupSlotMap] = useState({});

  // Memoria de PAX por slot (para que al quedar libre no vuelva a 2/0)
  const [slotPaxMap, setSlotPaxMap] = useState({}); // { [roomNumber]: { adults, children } }

  // === API existente ===
  const updateRoom = (roomNumber, isInCart) => {
    setRooms(prev =>
      prev.map(r => (r.roomNumber === Number(roomNumber) ? { ...r, isInCart: !!isInCart } : r))
    );
  };

  const addRoom = () => {
    setRooms(prev => ([
      ...prev,
      {
        adultsCount: 2,
        childrenCount: 0,
        isInCart: false,
        roomNumber: prev.length + 1,
        preferenceRate: false, // la primera puede ser true, el resto false
      }
    ]));
  };

  // === Mapeo groupId <-> slot ===
  const bindGroupToSlot = (groupId, roomNumber) => {
    if (!groupId || roomNumber == null) return;
    setGroupSlotMap(prev => {
      const next = { ...prev };
      // evitar duplicar slot con dos groupId
      for (const [gid, rn] of Object.entries(next)) {
        if (Number(rn) === Number(roomNumber) && gid !== String(groupId)) {
          delete next[gid];
        }
      }
      next[String(groupId)] = Number(roomNumber);
      return next;
    });
  };

  const unbindGroup = (groupId) => {
    if (!groupId) return;
    setGroupSlotMap(prev => {
      const next = { ...prev };
      delete next[String(groupId)];
      return next;
    });
  };

  // === PAX por slot ===
  const setSlotPax = (roomNumber, { adults = 0, children = 0 } = {}) => {
    if (roomNumber == null) return;
    setSlotPaxMap(prev => ({
      ...prev,
      [Number(roomNumber)]: {
        adults: Number(adults) || 0,
        children: Number(children) || 0,
      }
    }));
  };

  const getSlotPax = (roomNumber) => {
    if (roomNumber == null) return null;
    return slotPaxMap[Number(roomNumber)] || null;
  };

  // === Señal de cambio de PAX (para avisar a RoomTypeRatePlan) ===
  const [paxChangeSignal, setPaxChangeSignal] = useState({ seq: 0, changedSlots: [] });
  const signalPaxChange = (changedSlots = []) => {
    setPaxChangeSignal(prev => ({
      seq: prev.seq + 1,
      changedSlots: Array.from(new Set(changedSlots.map(Number))),
    }));
  };

  return (
    <RoomsContext.Provider
      value={{
        // existentes
        rooms, setRooms, updateRoom, addRoom,
        // mapeos
        groupSlotMap, bindGroupToSlot, unbindGroup,
        // pax persistidos por slot
        setSlotPax, getSlotPax,
        // señal pax
        paxChangeSignal, signalPaxChange,
      }}
    >
      {children}
    </RoomsContext.Provider>
  );
};

export default RoomsContext;
